<div class="dialog-header">
    <h2 mat-dialog-title>Add Fund Report</h2>
    <span class="dialog-header-spacer"></span>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="reportForm">
        <valumize-report-date-picker label="Report Date" formControlName="reportDate"></valumize-report-date-picker>
        @if (reportForm.controls.reportDate.hasError('reportDateNotUnique')) {
            <p class="add-fund-report-dialog__error">A report for this fund and report date already exists.</p>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button
            color="primary"
            data-test="add-report"
            [disabled]="reportForm.invalid"
            (click)="addReport()">
        Add report
    </button>
</mat-dialog-actions>
